// extracted by mini-css-extract-plugin
export default {"error_template":"NotFound_error_template__uvvtp","error_actions":"NotFound_error_actions__ii1cY","btn":"NotFound_btn__Fqdgp"};